import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Box, Button, IconButton, InputAdornment, Modal, TextField, Typography } from "@mui/material";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState } from "react";
import "./settings-modern.css";

function ChangePassword({ open, handleClose, user, addChangedUser, updatePage }) {
  const [showPassword, setShowPassword] = useState(false);
  const [invalid, setInvalid] = useState(false);
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setInvalid(false);
    if (password.length < 8) { setInvalid(true); return; }
    axios.put(
      `${process.env.React_APP_BACKEND_URL}/api/updateuser?id=${user.id}`,
      { password },
      { headers: { Authorization: `Bearer ${Cookies.get("token")}` } }
    ).then(() => {
      handleClose("password");
      if (addChangedUser) addChangedUser("password", password);
      if (updatePage) updatePage();
    }).catch((err) => console.log(err));
  };

  return (
    <Modal open={open} onClose={() => handleClose("password")} aria-labelledby="change-password-title">
      <Box className="bidit-settings-modal">
        <Box className="bidit-settings-head">
          <Typography id="change-password-title" className="bidit-settings-title">עדכון סיסמה</Typography>
          <Typography className="bidit-settings-subtitle">בחרו סיסמה חדשה באורך של לפחות 8 תווים.</Typography>
        </Box>
        <TextField
          fullWidth
          value={password}
          type={showPassword ? "text" : "password"}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="סיסמה חדשה"
          autoComplete="new-password"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton aria-label="הצגת סיסמה" onClick={() => setShowPassword((value) => !value)} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        {invalid && <Box className="bidit-settings-error">הסיסמה צריכה להכיל לפחות 8 תווים.</Box>}
        <Button fullWidth onClick={handleSubmit} variant="contained" className="bidit-settings-primary" sx={{ mt: 2.5 }}>שמירת הסיסמה</Button>
      </Box>
    </Modal>
  );
}
export default ChangePassword;
